import React from 'react'

const Services = () => {
  return (
    <section id="c-sectionServices" className="c-sectionWrapper">
		<div className="container">			
			<div className="row">				  
				<div className="col-xl-4 col-lg-12">
					<div className="c-sectionHeader text-left">
						<h5 className="c-heading46Bold">Lending Platform As a <span className="c-colorFinOrange">Services</span></h5>
						<p className="c-para20Light">Transparency and accuracy of data are provided to both the lender and the customer through our proprietary lending platform. A plug-and-play platform for FinTech’s can be customised according to their products and customers. Decisions can be made quickly and efficiently with a single consistent view.</p>
					</div>
				</div>
				<div className="col-xl-8 col-lg-12 c-sectionServicesCards">	
					<div className="row">
						<div className="col-sm-6 col-lg-5 col-xl-6 col-12 c-sectionServicesCol1">
							<div className="card c-servicesCard1">
							  <img src="./images/home/services/services_dashboard.png" alt="" title="" className="c-servicesCardIcon" />
							  <div className="card-body">
								<h5 className="card-title">Dashboard</h5>
								<a href="#" className="c-servicesCardArrow">
									<img src="./images/home/services/arrow_next.png" alt="" title="" />
								</a>
							  </div>
							</div>							
							<div className="card c-servicesCard2">
							  <img src="images/home/services/services_apis.png" alt="" title="" className="c-servicesCardIcon" />
							  <div className="card-body">
								<h5 className="card-title">FI-MEN </h5>
								<a href="#" className="c-servicesCardArrow">
									<img src="./images/home/services/arrow_next.png" alt="" title="" />
								</a>
							  </div>
							</div>
						</div>
						<div className="col-sm-6 col-lg-5 col-xl-6 col-12 c-sectionServicesCol2">					
							<div className="card c-servicesCard3">
							  <img src="./images/home/services/services_elap.png" alt="" title="" className="c-servicesCardIcon" />
							  <div className="card-body">
								<h5 className="card-title">100+ API’s</h5>
								<a href="#" className="c-servicesCardArrow">
									<img src="./images/home/services/arrow_next.png" alt="" title="" />
								</a>
							  </div>
							</div>
						</div>
					</div>
				</div>
			</div>			
		</div>
	</section>
  )
}

export default Services